import type { SetElementTypeNameStatusInPlan } from "./types";

export const setElementTypeNameStatusInPlan: SetElementTypeNameStatusInPlan = ({
  plan,
  elementTypeIds,
  nameStatus,
}) => {
  if (elementTypeIds.length === 0) return plan;
  const targetIds = new Set(elementTypeIds);

  let didChange = false;
  const nextGroupMeta: typeof plan.groupMeta = {};
  for (const [groupLabel, meta] of Object.entries(plan.groupMeta)) {
    if (targetIds.has(meta.element_type_id) && meta.nameStatus !== nameStatus) {
      nextGroupMeta[groupLabel] = { ...meta, nameStatus };
      didChange = true;
    } else {
      nextGroupMeta[groupLabel] = meta;
    }
  }

  if (!didChange) return plan;
  return { ...plan, groupMeta: nextGroupMeta };
};
